module.exports = __webpack_public_path__ + "img/confirm.dc6fbec6.png";